import { ResponsePaging } from './../../nest-responses';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NestApiProvider, FormDataUpload } from "../../nest-api";
import {
  RequestCreateDepartmentDto,
  RequestDeleteDepartmentByDto, ResponseCreateDepartmentDto,
  ResponseDeleteDepartmentByDto,
  ResponseDepartement,
  ResponseGetOrganizationDto
} from "../dto/department.dto";

@Injectable()
export class DepartmentApi {
  private service: string = '';
  private model: string = 'department';

  constructor(
    private nestApiProvider: NestApiProvider
  ) {
  }


  public getOrganization(): Observable<ResponseGetOrganizationDto> {
    const method: string = 'GET';
    const func: string = 'getOrganization';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetOrganizationDto>(method, url, func, params, body);
  }

  public deleteDepartmentBy(data: RequestDeleteDepartmentByDto): Observable<ResponseDeleteDepartmentByDto> {
    const method: string = 'POST';
    const func: string = 'deleteDepartmentBy';
    const params: any = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseDeleteDepartmentByDto>(method, url, params, urlParams, body);
  }

  public createDepartment(data: RequestCreateDepartmentDto): Observable<ResponseCreateDepartmentDto> {
    const method: string = 'POST';
    const func: string = 'createDepartment';
    const params: RequestCreateDepartmentDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseCreateDepartmentDto>(method, url, params, urlParams, body);
  }

  public downloadTemplate(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'downloadTemplate';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, func, params, body);
  }

  public uploadDepartment(file: File): Observable<any> {
    const method: string = 'POST';
    const func: string = 'uploadDepartment';
    const params: FormDataUpload[] = [];
    params.push({ name: 'file', value: file });
    const urlParams: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestUpload(method, url, params);
  }

  public findDepartment(): Observable<ResponsePaging<ResponseDepartement>> {
    const method: string = 'GET';
    const func: string = 'findDepartment';
    const params: any = {};
    const urlParams: any = { limit: 1000 };
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePaging<ResponseDepartement>>(method, url, func, params, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/department.api.ts